import addonReducer from "./slices/addonSlice";
import attributeReducer from "./slices/attributeSlice";
import authReducer from "./slices/authSlice";
import cartReducer from "./slices/cartSlice";
import categoryReducer from "./slices/categorySlice";
import customerReducer from "./slices/customerSlice";
import dashboardReducer from "./slices/dashboardSlice";
import dineReducer from "./slices/dineSlice";
import itemReducer from "./slices/itemSlice";
import kotReducer from "./slices/kotSlice";
import menuReducer from "./slices/menuSlice";
import orderHistoryReducer from "./slices/orderHistorySlice";
import orderReducer from "./slices/orderSlice";
import progressReducer from "./slices/progressSlice";
import reportReducer from "./slices/reportSlice";
import storeReducer from "./slices/storeSlice";
import tableReducer from "./slices/tableSlice";
import userReducer from "./slices/userSlice";

const rootReducer = {
  auth: authReducer,
  progress: progressReducer,
  menu: menuReducer,
  dine: dineReducer,
  store: storeReducer,
  customer: customerReducer,
  table: tableReducer,
  order: orderReducer,
  cart: cartReducer,
  category: categoryReducer,
  attribute: attributeReducer,
  addon: addonReducer,
  item: itemReducer,
  kot: kotReducer,
  dashboard: dashboardReducer,
  orderHistory: orderHistoryReducer,
  report: reportReducer,
  user: userReducer,
};

export default rootReducer;
